import { Link, useParams } from "react-router-dom";
import MobileForm from "../../../../../../components/MobileForm";
import { makeStyles } from '@material-ui/core';
import { Box }  from '@material-ui/core';
import { useEffect, useState } from "react";
import useAPI from 'hooks/useAPI';
import useCustomer from 'hooks/useCustomer';

const useStyles = makeStyles({
  formButton: {
    width: '30px',
    background: '#6271CB',
    color: 'white',
    borderRadius: 5,
    display: 'block',
    textDecoration: 'none',
    textAlign: 'center',
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 7,
    marginLeft: 20,
    marginRight: 20,
  }
});

export default function InspectionPage4() {
  const styles = useStyles()
  const { version, appointmentId, enrollmentNumber } = useParams();
  const useValidation = require(`./v${version}/useValidation`).default;
  const background = require(`./v${version}/background.png`);
  const fields = require(`./v${version}/fields.json`);
  const { width: bgWidth, height: bgHeight } = require(`./v${version}/dimensions.json`);
  const [submissions, setSubmissions] = useState([]);
  const { customer } = useCustomer(enrollmentNumber);
  const api = useAPI();

  const getForms = () => {
    return api 
      .get(`/appointments/${appointmentId}/submissions`)
      .then(res => setSubmissions(res.data.submissions))
      .catch(err => console.log(err))
  };


  // const [kBtuhValues, setKBtuhValues] = useState({
  //   input1: 0,
  //   input2: 0,
  //   input3: 0,
  //   input4: 0
  // })
  // const [area1Values, setArea1Values] = useState({
  //   length: 0,
  //   width: 0,
  //   height: 0,
  // })
  // const [area2Values, setArea2Values] = useState({
  //   length: 0,
  //   width: 0,
  //   height: 0,
  // })
  // const [area3Values, setArea3Values] = useState({
  //   length: 0,
  //   width: 0,
  //   height: 0,
  // })
  // const [area4Values, setArea4Values] = useState({
  //   length: 0,
  //   width: 0,
  //   height: 0,
  // })
  // const [outdoorArea1Values, setOutdoorArea1Values] = useState({
  //   width: 0,
  //   height: 0,
  //   reductionFactor: 0,
  //   quantity: 0
  // });
  // const [outdoorArea2Values, setOutdoorArea2Values] = useState({
  //   width: 0,
  //   height: 0,
  //   reductionFactor: 0,
  //   quantity: 0
  // });
  // const [outdoorArea3Values, setOutdoorArea3Values] = useState({
  //   width: 0,
  //   height: 0,
  //   reductionFactor: 0,
  //   quantity: 0
  // });

  // const [totalKBtuh, setTotalKBtuh] = useState(0);
  // const [totalArea1, setTotalArea1] = useState(0);
  // const [totalArea2, setTotalArea2] = useState(0);
  // const [totalArea3, setTotalArea3] = useState(0);
  // const [totalArea4, setTotalArea4] = useState(0);
  // const [totalVolumeState, setTotalVolume] = useState(0);
  // const [totalKBtuhFinal, setTotalKBtuhFinal] = useState(0);
  // const [outdoorArea1, setOutdoorArea1] = useState(0);
  // const [outdoorArea2, setOutdoorArea2] = useState(0);
  // const [outdoorArea3, setOutdoorArea3] = useState(0);

  const width = document.documentElement.clientWidth;
  const ratio = width / bgWidth;
  const newHeight = bgHeight * ratio;

  // const db = useDb();
// 
  // const cacheTotalKBtuh = async (totalKBtuh, area1Total, area2Total, area3Total, area4Total, totalVolume, finalKBtuh, area1, area2, area3) => {
    // return db.forms
      // .where({
        // appointmentId, 
        // type: 'inspectionPage4', 
        // version
      // })
      // .modify({
        //  'totalKBtuh': totalKBtuh,
        //  'area1_volume': area1Total,
        //  'area2_volume': area2Total,
        //  'area3_volume': area3Total,
        //  'area4_volume': area4Total,
        //  'totalVolume': totalVolume,
        //  'totalKBtuhx50': finalKBtuh, 
        //  'vent1_area': area1,
        //  'vent2_area': area2,
        //  'vent3_area': area3
        // })
      // .catch(err => console.log(err))
  // }
// 
  // const handleTotalKBtuh = async () => {  
    // try {
      // const record = await db.forms
        // .where({ appointmentId, type: 'inspectionPage4', version })
        // .first(); 
// 
      // if (record) {
        // const {
          // kBtuhInput_1, kBtuhInput_2, kBtuhInput_3, kBtuhInput_4,
          // area1_length, area1_width, area1_height,
          // area2_length, area2_width, area2_height,
          // area3_length, area3_width, area3_height,
          // area4_length, area4_width, area4_height,
          // vent1_width, vent1_height, vent1_reductionFactor, vent1_quantity,
          // vent2_width, vent2_height, vent2_reductionFactor, vent2_quantity,
          // vent3_width, vent3_height, vent3_reductionFactor, vent3_quantity,
        //  } = record;
// 
        // setKBtuhValues({
          // input1: kBtuhInput_1,
          // input2: kBtuhInput_2,
          // input3: kBtuhInput_3,
          // input4: kBtuhInput_4
        // })
        // setArea1Values({
          // length: area1_length,
          // width: area1_width,
          // height: area1_height
        // })
        // setArea2Values({
          // length: area2_length,
          // width: area2_width,
          // height: area2_height
        // })
        // setArea3Values({
          // length: area3_length,
          // width: area3_width,
          // height: area3_height
        // })
        // setArea4Values({
          // length: area4_length,
          // width: area4_width,
          // height: area4_height
        // })
        // setOutdoorArea1Values({
          // length: vent1_height,
          // width: vent1_width,
          // reductionFactor: vent1_reductionFactor,
          // quantity: vent1_quantity
        // })
        // setOutdoorArea2Values({
          // length: vent2_height,
          // width: vent2_width,
          // reductionFactor: vent2_reductionFactor,
          // quantity: vent2_quantity
        // })
        // setOutdoorArea1Values({
          // length: vent3_height,
          // width: vent3_width,
          // reductionFactor: vent3_reductionFactor,
          // quantity: vent3_quantity
        // })
// 
        // const value1 = parseFloat(kBtuhInput_1) || 0;
        // const value2 = parseFloat(kBtuhInput_2) || 0;
        // const value3 = parseFloat(kBtuhInput_3) || 0;
        // const value4 = parseFloat(kBtuhInput_4) || 0;
// 
        // const area1LengthValue = parseFloat(area1_length) || 0;
        // const area1WidthValue = parseFloat(area1_width) || 0;
        // const area1HeightValue = parseFloat(area1_height) || 0;
// 
        // const area2LengthValue = parseFloat(area2_length) || 0;
        // const area2WidthValue = parseFloat(area2_width) || 0;
        // const area2HeightValue = parseFloat(area2_height) || 0;
// 
        // const area3LengthValue = parseFloat(area3_length) || 0;
        // const area3WidthValue = parseFloat(area3_width) || 0;
        // const area3HeightValue = parseFloat(area3_height) || 0;
// 
        // const area4LengthValue = parseFloat(area4_length) || 0;
        // const area4WidthValue = parseFloat(area4_width) || 0;
        // const area4HeightValue = parseFloat(area4_height) || 0;
// 
        // const outdoorArea1LengthValue = parseFloat(vent1_height) || 0;
        // const outdoorArea1WidthValue = parseFloat(vent1_width) || 0;
        // const outdoorArea1ReductionFactorValue = parseFloat(vent1_reductionFactor) || 0;
        // const outdoorArea1QuantityValue = parseFloat(vent1_quantity) || 0;
// 
        // const outdoorArea2LengthValue = parseFloat(vent2_height) || 0;
        // const outdoorArea2WidthValue = parseFloat(vent2_width) || 0;
        // const outdoorArea2ReductionFactorValue = parseFloat(vent2_reductionFactor) || 0;
        // const outdoorArea2QuantityValue = parseFloat(vent2_quantity) || 0;
// 
        // const outdoorArea3LengthValue = parseFloat(vent3_height) || 0;
        // const outdoorArea3WidthValue = parseFloat(vent3_width) || 0;
        // const outdoorArea3ReductionFactorValue = parseFloat(vent3_reductionFactor) || 0;
        // const outdoorArea3QuantityValue = parseFloat(vent3_quantity) || 0;
// 
        // const kBtuhSum = value1 + value2 + value3 + value4;
        // const area1Total = (area1LengthValue * area1WidthValue) * area1HeightValue;
        // const area2Total = (area2LengthValue * area2WidthValue) * area2HeightValue;
        // const area3Total = (area3LengthValue * area3WidthValue) * area3HeightValue;
        // const area4Total = (area4LengthValue * area4WidthValue) * area4HeightValue;
        // const totalVolume = area1Total + area2Total + area3Total + area4Total;
        // const finalKBtuh = kBtuhSum * 50;
        // const outdoorArea1Total = outdoorArea1LengthValue * outdoorArea1WidthValue * outdoorArea1ReductionFactorValue * outdoorArea1QuantityValue;
        // const outdoorArea2Total = outdoorArea2LengthValue * outdoorArea2WidthValue * outdoorArea2ReductionFactorValue * outdoorArea2QuantityValue;
        // const outdoorArea3Total = outdoorArea3LengthValue * outdoorArea3WidthValue * outdoorArea3ReductionFactorValue * outdoorArea3QuantityValue;
// 
        // await cacheTotalKBtuh(kBtuhSum, area1Total, area2Total, area3Total, area4Total, totalVolume, finalKBtuh, outdoorArea1Total, outdoorArea2Total, outdoorArea3Total);
// 
        // setTotalKBtuh(kBtuhSum);
        // setTotalArea1(area1Total);
        // setTotalArea2(area2Total);
        // setTotalArea3(area3Total);
        // setTotalArea4(area4Total);
        // setTotalVolume(totalVolume);
        // setTotalKBtuhFinal(finalKBtuh);
        // setOutdoorArea1(outdoorArea1Total)
        // setOutdoorArea2(outdoorArea2Total)
        // setOutdoorArea3(outdoorArea3Total)
// 
        // console.log(`Calculated total kBtuh: ${kBtuhSum}`);
        // console.log(`Calculated total outdoor area 1: ${outdoorArea1Total}`);
      // }
    // }
    // catch (err) {
      // console.log(err);
    // }
  // };
// 
  // const handleFieldChange = (fieldName, value) => {
    // setKBtuhValues((prevValues) => ({
      // ...prevValues,
      // [fieldName]: value, 
    // }));
  // };
// 
  // useEffect(() => {
    // handleTotalKBtuh();
  // }, [totalKBtuh]);
// 
  useEffect(() => {
    if(customer) {
      getForms();
    }
  }, [customer]);

  const targetIds = [
    '6778499945b2d61140c550b5',
    '67784e1145b2d61140c550b6',
    '67784e2345b2d61140c550b7',
    '67784e3745b2d61140c550b9',
    '67784e3e45b2d61140c550ba',
    '67784e4745b2d61140c550bb',
    '67784e5045b2d61140c550bc',
    '67784e5a45b2d61140c550bd',
    '67784e6445b2d61140c550be',
    '67784e6c45b2d61140c550bf',
  ]

  const matchingSubmissionIds = submissions
    .filter(submission => targetIds.includes(submission.form._id))
    .map(submission => {
      // Extract the numeric page number from the form abbreviation (e.g., repairedAndReplacedPage3 -> 3)
      const match = submission.form.abbr.match(/Page(\d+)/i);
      const pageNumber = match ? parseInt(match[1], 10) : Infinity; // default to Infinity if no match
      return { ...submission, pageNumber };
  })
  .sort((a, b) => a.pageNumber - b.pageNumber); // Sort by page number

  return (
    <div>
      <MobileForm
        type="inspectionPage4"
        version={version}
        width={width}
        height={newHeight}
        useValidation={useValidation}
        background={background}
        fields={fields}
      />
      <Box display="flex" flexDirection="row">
        {matchingSubmissionIds.map(submission => (
          <Link
            key={submission._id}
            to={`/customers/${enrollmentNumber}/appointment/${appointmentId}/form/${submission.form.abbr}/${version}/${submission._id}`}
            className={styles.formButton}
          >
            {submission.pageNumber}
          </Link>
        ))}
      </Box>
    </div>
  );
};